export const RANGES_MAX_QUANTITY = 5;
